import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'
import {UPDATE_POINTS_OF_ACTION_CASE} from '../../queries/Queries'
import { useMutation } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';

class PointsOfActionCase extends Component {
  state = {
    points_value: '',
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = { points_value: props.pointsOfActionCase.points_value };
  }


  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    let elements = React.Children.toArray(this.props.children)
    let updateButton
    if(elements.length === 1)
      updateButton = React.cloneElement(elements[0], {state: this.state, id: this.props.pointsOfActionCase.id})
    return (
      <tr>
        <td>{this.props.pointsOfActionCase.id}</td>
        <td>{this.props.pointsOfActionCase.action_case}</td>
        <td>
          { 
          token && !this.props.locked ?
          <Update 
            onChange={(state) => this.setState(state)}
            state={this.state}
            props={this.props}
          />
          : 
          <div>{this.props.pointsOfActionCase.points_value}</div> 
          }
          </td>
          {token && !this.props.locked && updateButton !== undefined &&
          <td>{ updateButton }</td>}
      </tr>
    )
  } 

}

function Update({ onChange, state, props }) {
  const [upadateEntry, {loading, error}] = useMutation(UPDATE_POINTS_OF_ACTION_CASE)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) {
    console.log("ERROR:"+error)
    alert("Update Points of action case Error: "+ error.message)
  }

  return (
    <input
      value={state.points_value}
      onChange={e => onChange({points_value: e.target.value})}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          upadateEntry({ variables: {id: props.pointsOfActionCase.id, points_value: parseInt(state.points_value)} })
        }
      }}
      type="text"
      placeholder="Cost of Action -/+ Points"
    /> 
  )
}

export default PointsOfActionCase